var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 30,
    viewBox: "0 0 9 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35189 20.4857C5.34518 20.4856 6.29993 20.1012 7.01613 19.413C7.73234 18.7247 8.15444 17.786 8.19402 16.7935L8.7008 3.99642C8.72114 3.47914 8.63682 2.96308 8.4529 2.47918C8.26899 1.99528 7.98925 1.5535 7.63048 1.18031C7.2717 0.807127 6.84126 0.510227 6.36497 0.30741C5.88868 0.104592 5.37634 3.30621e-05 4.85867 0H3.8451C3.32742 3.30621e-05 2.81509 0.104592 2.3388 0.30741C1.86251 0.510227 1.43207 0.807127 1.07329 1.18031C0.714515 1.5535 0.434785 1.99528 0.250867 2.47918C0.0669489 2.96308 -0.0173693 3.47914 0.00296879 3.99642L0.509754 16.7935C0.549331 17.786 0.971429 18.7247 1.68764 19.413C2.40384 20.1012 3.35859 20.4856 4.35189 20.4857Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.512264 26.1612C0.512264 24.041 2.231 22.3223 4.35118 22.3223C6.47136 22.3223 8.1901 24.041 8.1901 26.1612C8.1901 28.2814 6.47136 30.0001 4.35118 30.0001C2.231 30.0001 0.512264 28.2814 0.512264 26.1612Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.1b8df57e55e2dc57da9fc8bc9c49a275.svg";
export { ForwardRef as ReactComponent };